<template>
    <div class="form-group col-12">
        <div v-for="(item, index) in content.slides" :key="index">
            <h6
                class="col-12 mt-4 p-2 bg-light text-uppercase text-center align-items-center d-flex"
            >
                <button
                    v-if="content.slides.length > 1"
                    class="col-md-1 col-sm-2 col-3 btn btn-danger waves-effect waves-ligh mr-3"
                    type="button"
                    @click="removeItem(index)"
                >
                    <i class="far fa-trash-alt" />
                </button>
                #{{ index + 1 }}
            </h6>
            <div class="row">
                <div class="form-group col-md-6 col-12">
                    <label :for="`upperText_${index}`">Upper text</label>
                    <input
                        :id="`upperText_${index}`"
                        v-model="item.upperText"
                        class="form-control"
                        :class="{
                            'is-invalid': v.slides.$each[index].upperText.$error
                        }"
                        dir="auto"
                    />
                </div>
                <div class="form-group col-md-6 col-12">
                    <label :for="`lowerText_${index}`">Lower text</label>
                    <input
                        :id="`lowerText_${index}`"
                        v-model="item.lowerText"
                        class="form-control"
                        :class="{
                            'is-invalid': v.slides.$each[index].lowerText.$error
                        }"
                        dir="auto"
                    />
                </div>
                <div class="form-group col-md-6 col-12">
                    <label :for="`buttonText_${index}`">Button text</label>
                    <input
                        :id="`buttonText_${index}`"
                        v-model="item.buttonText"
                        class="form-control"
                        :class="{
                            'is-invalid':
                                v.slides.$each[index].buttonText.$error
                        }"
                        dir="auto"
                    />
                </div>
                <div class="form-group col-md-6 col-12">
                    <label :for="`buttonLink_${index}`">Button link</label>
                    <input
                        :id="`buttonLink_${index}`"
                        v-model="item.buttonLink"
                        class="form-control"
                        :class="{
                            'is-invalid':
                                v.slides.$each[index].buttonLink.$error
                        }"
                        dir="auto"
                    />
                </div>
                <div class="form-group col-12">
                    <label :for="`image_${index}`">Image</label>
                    <media-chooser
                        :id="`image_${index}`"
                        v-model="item.image"
                        type="image"
                        :error-border="v.slides.$each[index].image.$error"
                    />
                </div>
            </div>
        </div>
        <button
            class="btn btn-success waves-effect waves-light mr-1 mt-4"
            type="button"
            @click="addItem"
        >
            <i class="fas fa-plus-circle" /> Add Item
        </button>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        v: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            content: {
                slides: []
            }
        };
    },

    watch: {
        content() {
            this.$emit('input', this.content);
        }
    },

    mounted() {
        this.content = { ...this.content, ...this.value };

        if (!this.content.slides.length) {
            this.addItem();
        }
    },

    methods: {
        addItem() {
            this.content.slides.push({
                image: '',
                title: '',
                redirect: '',
                premiumOnly: false
            });
        },

        removeItem(index) {
            this.content.slides.splice(index, 1);
        }
    }
};
</script>
